export const categories = [
  {
    slug: 'slots',
    name: '老虎机',
    icon: 'ri-gamepad-line',
    description: '经典与创新老虎机游戏，丰富主题任你选择',
    games: [
      { id: 1, name: '宝石迷阵', image: 'https://readdy.ai/api/search-image?query=colorful%20slot%20machine%20game%20with%20gem%20theme%20vibrant%20jewel%20symbols%20luxurious%20golden%20frame%20dark%20background%20casino%20game%20art%20style%20clean%20simple%20background%20high%20quality%20gaming%20banner&width=400&height=300&seq=slot-game-01&orientation=landscape', players: '12.8万', rating: 4.9 },
      { id: 2, name: '水果派对', image: 'https://readdy.ai/api/search-image?query=fruit%20themed%20slot%20machine%20game%20bright%20juicy%20fruits%20watermelon%20cherry%20lemon%20symbols%20playful%20colorful%20design%20clean%20dark%20background%20gaming%20banner%20style&width=400&height=300&seq=slot-game-02&orientation=landscape', players: '9.5万', rating: 4.7 },
      { id: 3, name: '埃及宝藏', image: 'https://readdy.ai/api/search-image?query=ancient%20egypt%20themed%20slot%20machine%20game%20pharaoh%20pyramid%20hieroglyphics%20golden%20artifacts%20mysterious%20dark%20background%20warm%20golden%20tones%20gaming%20banner%20style&width=400&height=300&seq=slot-game-03&orientation=landscape', players: '15.3万', rating: 4.8 },
      { id: 4, name: '幸运777', image: 'https://readdy.ai/api/search-image?query=classic%20lucky%20seven%20slot%20machine%20game%20red%20gold%20traditional%20casino%20style%20number%20seven%20symbols%20warm%20dark%20background%20elegant%20gaming%20banner&width=400&height=300&seq=slot-game-04&orientation=landscape', players: '18.6万', rating: 4.9 },
      { id: 5, name: '海洋奇缘', image: 'https://readdy.ai/api/search-image?query=ocean%20adventure%20themed%20slot%20game%20underwater%20sea%20creatures%20dolphins%20pearls%20blue%20cyan%20waves%20deep%20sea%20background%20clean%20gaming%20banner%20style&width=400&height=300&seq=slot-game-05&orientation=landscape', players: '11.2万', rating: 4.6 },
      { id: 6, name: '龙之传说', image: 'https://readdy.ai/api/search-image?query=chinese%20dragon%20themed%20slot%20game%20golden%20dragon%20red%20lanterns%20traditional%20chinese%20patterns%20festive%20warm%20atmosphere%20dark%20background%20gaming%20banner%20style&width=400&height=300&seq=slot-game-06&orientation=landscape', players: '20.1万', rating: 5.0 },
    ],
  },
  {
    slug: 'board',
    name: '棋牌游戏',
    icon: 'ri-vip-crown-line',
    description: '经典棋牌对战，真人实时匹配，公平竞技',
    games: [
      { id: 7, name: '百家乐', image: 'https://readdy.ai/api/search-image?query=baccarat%20card%20game%20elegant%20green%20felt%20table%20playing%20cards%20chips%20luxurious%20casino%20atmosphere%20dark%20background%20gaming%20banner%20style&width=400&height=300&seq=board-game-01&orientation=landscape', players: '22.3万', rating: 4.8 },
      { id: 8, name: '德州扑克', image: 'https://readdy.ai/api/search-image?query=texas%20holdem%20poker%20game%20playing%20cards%20poker%20chips%20green%20table%20professional%20casino%20style%20dark%20background%20gaming%20banner&width=400&height=300&seq=board-game-02&orientation=landscape', players: '19.7万', rating: 4.7 },
      { id: 9, name: '斗地主', image: 'https://readdy.ai/api/search-image?query=chinese%20card%20game%20dou%20dizhu%20playing%20cards%20colorful%20traditional%20design%20warm%20background%20gaming%20atmosphere%20clean%20banner%20style&width=400&height=300&seq=board-game-03&orientation=landscape', players: '28.4万', rating: 4.9 },
      { id: 10, name: '牛牛', image: 'https://readdy.ai/api/search-image?query=chinese%20niu%20niu%20card%20game%20playing%20cards%20red%20and%20gold%20festive%20chinese%20design%20warm%20dark%20background%20gaming%20banner%20style&width=400&height=300&seq=board-game-04&orientation=landscape', players: '16.8万', rating: 4.6 },
      { id: 11, name: '炸金花', image: 'https://readdy.ai/api/search-image?query=zha%20jinhua%20chinese%20poker%20game%20three%20cards%20golden%20and%20red%20traditional%20chinese%20design%20dark%20background%20gaming%20banner%20style&width=400&height=300&seq=board-game-05&orientation=landscape', players: '14.5万', rating: 4.7 },
      { id: 12, name: '21点', image: 'https://readdy.ai/api/search-image?query=blackjack%20twenty%20one%20card%20game%20playing%20cards%20chips%20green%20felt%20table%20classic%20casino%20elegant%20dark%20background%20gaming%20banner&width=400&height=300&seq=board-game-06&orientation=landscape', players: '17.9万', rating: 4.8 },
    ],
  },
  {
    slug: 'fishing',
    name: '捕鱼游戏',
    icon: 'ri-anchor-line',
    description: '深海捕鱼乐趣多，多种武器任你选择',
    games: [
      { id: 13, name: '深海捕鱼', image: 'https://readdy.ai/api/search-image?query=underwater%20fishing%20game%20colorful%20tropical%20fish%20coral%20reef%20deep%20ocean%20blue%20background%20bubbles%20sea%20creatures%20gaming%20banner%20style&width=400&height=300&seq=fish-game-01&orientation=landscape', players: '13.6万', rating: 4.5 },
      { id: 14, name: '龙王捕鱼', image: 'https://readdy.ai/api/search-image?query=dragon%20king%20fishing%20game%20golden%20dragon%20fish%20underwater%20mythical%20sea%20creatures%20rich%20gold%20and%20blue%20colors%20dark%20ocean%20background%20gaming%20banner&width=400&height=300&seq=fish-game-02&orientation=landscape', players: '16.2万', rating: 4.8 },
      { id: 15, name: '欢乐捕鱼', image: 'https://readdy.ai/api/search-image?query=happy%20fishing%20arcade%20game%20cartoon%20style%20colorful%20fish%20fun%20underwater%20scene%20bright%20cheerful%20colors%20clean%20background%20gaming%20banner%20style&width=400&height=300&seq=fish-game-03&orientation=landscape', players: '10.8万', rating: 4.4 },
      { id: 16, name: '捕鱼达人', image: 'https://readdy.ai/api/search-image?query=fishing%20master%20game%20sharks%20whales%20deep%20sea%20hunting%20weapons%20torpedoes%20cannons%20underwater%20battle%20dark%20ocean%20background%20gaming%20banner&width=400&height=300&seq=fish-game-04&orientation=landscape', players: '19.4万', rating: 4.7 },
      { id: 17, name: '千炮捕鱼', image: 'https://readdy.ai/api/search-image?query=thousand%20cannon%20fishing%20game%20massive%20underwater%20battle%20laser%20cannons%20exploding%20fish%20epic%20sea%20scene%20dark%20blue%20background%20gaming%20banner&width=400&height=300&seq=fish-game-05&orientation=landscape', players: '12.7万', rating: 4.6 },
      { id: 18, name: '金鲨银鲨', image: 'https://readdy.ai/api/search-image?query=golden%20shark%20silver%20shark%20fishing%20game%20luxurious%20underwater%20scene%20gold%20silver%20sharks%20treasures%20deep%20ocean%20dark%20background%20gaming%20banner&width=400&height=300&seq=fish-game-06&orientation=landscape', players: '15.1万', rating: 4.7 },
    ],
  },
  {
    slug: 'sports',
    name: '体育电竞',
    icon: 'ri-football-line',
    description: '全球热门赛事竞猜，实时赔率即时结算',
    games: [
      { id: 19, name: '足球竞猜', image: 'https://readdy.ai/api/search-image?query=football%20soccer%20betting%20game%20stadium%20green%20field%20players%20action%20sports%20atmosphere%20dark%20background%20gaming%20banner%20style&width=400&height=300&seq=sports-game-01&orientation=landscape', players: '25.6万', rating: 4.8 },
      { id: 20, name: '篮球竞猜', image: 'https://readdy.ai/api/search-image?query=basketball%20betting%20game%20court%20action%20dunk%20players%20orange%20ball%20dark%20sports%20arena%20background%20gaming%20banner%20style&width=400&height=300&seq=sports-game-02&orientation=landscape', players: '21.3万', rating: 4.7 },
      { id: 21, name: '电竞LOL', image: 'https://readdy.ai/api/search-image?query=league%20of%20legends%20esports%20game%20champions%20battle%20arena%20colorful%20digital%20art%20dark%20background%20gaming%20banner%20style&width=400&height=300&seq=sports-game-03&orientation=landscape', players: '18.9万', rating: 4.9 },
      { id: 22, name: '电竞DOTA', image: 'https://readdy.ai/api/search-image?query=dota%202%20esports%20game%20epic%20battle%20heroes%20dark%20fantasy%20arena%20atmosphere%20gaming%20banner%20style%20clean%20composition&width=400&height=300&seq=sports-game-04&orientation=landscape', players: '14.7万', rating: 4.6 },
      { id: 23, name: '网球竞猜', image: 'https://readdy.ai/api/search-image?query=tennis%20betting%20game%20court%20player%20serving%20action%20green%20tennis%20court%20dark%20background%20sports%20gaming%20banner%20style&width=400&height=300&seq=sports-game-05&orientation=landscape', players: '11.2万', rating: 4.5 },
      { id: 24, name: '综合赛事', image: 'https://readdy.ai/api/search-image?query=multiple%20sports%20betting%20game%20collage%20football%20basketball%20tennis%20volleyball%20dark%20sports%20atmosphere%20gaming%20banner%20style&width=400&height=300&seq=sports-game-06&orientation=landscape', players: '20.5万', rating: 4.8 },
    ],
  },
  {
    slug: 'lottery',
    name: '彩票游戏',
    icon: 'ri-ticket-line',
    description: '多种彩票玩法，实时开奖公正透明',
    games: [
      { id: 25, name: '时时彩', image: 'https://readdy.ai/api/search-image?query=chinese%20lottery%20game%20colorful%20number%20balls%20lucky%20draw%20red%20and%20gold%20festive%20design%20dark%20background%20gaming%20banner%20style&width=400&height=300&seq=lottery-game-01&orientation=landscape', players: '30.1万', rating: 4.9 },
      { id: 26, name: '快乐8', image: 'https://readdy.ai/api/search-image?query=happy%20eight%20lottery%20game%20golden%20balls%20with%20numbers%20festive%20celebration%20atmosphere%20red%20gold%20design%20dark%20background%20gaming%20banner&width=400&height=300&seq=lottery-game-02&orientation=landscape', players: '26.8万', rating: 4.8 },
      { id: 27, name: '六合彩', image: 'https://readdy.ai/api/search-image?query=mark%20six%20lottery%20game%20numbered%20balls%20drawn%20traditional%20chinese%20red%20and%20gold%20design%20dark%20background%20gaming%20banner%20style&width=400&height=300&seq=lottery-game-03&orientation=landscape', players: '22.4万', rating: 4.7 },
      { id: 28, name: '11选5', image: 'https://readdy.ai/api/search-image?query=choose%20eleven%20from%20five%20lottery%20game%20number%20balls%20bright%20lucky%20colors%20modern%20design%20dark%20background%20gaming%20banner%20style&width=400&height=300&seq=lottery-game-04&orientation=landscape', players: '18.3万', rating: 4.6 },
      { id: 29, name: 'PK10', image: 'https://readdy.ai/api/search-image?query=pk%20ten%20racing%20lottery%20game%20race%20cars%20speed%20track%20excitement%20checkered%20flag%20dark%20racing%20background%20gaming%20banner%20style&width=400&height=300&seq=lottery-game-05&orientation=landscape', players: '16.9万', rating: 4.7 },
      { id: 30, name: '3D彩', image: 'https://readdy.ai/api/search-image?query=three%20digit%20lottery%20game%20number%20digits%20floating%20golden%203D%20numbers%20shiny%20design%20dark%20background%20gaming%20banner%20style&width=400&height=300&seq=lottery-game-06&orientation=landscape', players: '14.5万', rating: 4.5 },
    ],
  },
];

export const articles = [
  {
    id: 1,
    slug: 'pg-gaming-guide-2024',
    title: 'PG国际008新手入门完全指南：从下载到精通',
    excerpt: '本文为PG国际008新玩家提供从下载安装到游戏上手的完整指南，涵盖平台注册、游戏规则、充值提现等核心操作流程。',
    content: `PG国际008作为全球领先的在线游戏平台，为玩家提供了丰富多样的游戏体验。本文将详细介绍如何快速上手PG国际008，从下载安装到精通各种游戏玩法。

## 一、下载与安装

### iOS设备安装指南
1. 访问PG国际008官方网站，点击iOS下载按钮
2. 根据提示完成企业证书信任设置
3. 在设置 &gt; 通用 &gt; 设备管理中信任PG国际证书
4. 返回桌面，即可开始游戏

### Android设备安装指南
1. 访问PG国际008官方网站，点击Android下载按钮
2. 下载APK安装包后，允许安装未知来源应用
3. 完成安装后打开应用，注册或登录账号

## 二、新手上路必知

PG国际008平台提供了老虎机、棋牌、捕鱼、体育竞猜、彩票等多种游戏类型。新玩家建议从以下方向入手：
- 先试玩免费模式，熟悉游戏规则
- 设定每日游戏预算，理性娱乐
- 关注平台活动，领取新手礼包

## 三、平台核心功能

PG国际008平台具备以下核心功能：
- 一键下载安装，支持iOS/Android全平台
- 丰富的游戏类型，总有你喜欢的
- 安全可靠的支付系统，支持多种充值方式
- 24小时在线客服，随时解答疑问`,
    image: 'https://readdy.ai/api/search-image?query=beginner%20guide%20to%20online%20gaming%20platform%20mobile%20phone%20showing%20game%20interface%20warm%20dark%20background%20tutorial%20style%20clean%20composition&width=800&height=450&seq=article-01&orientation=landscape',
    category: '攻略教程',
    date: '2026-08-08',
    views: '15.6万',
    tags: ['新手入门', '下载指南', 'PG国际008'],
  },
  {
    id: 2,
    slug: 'pg-slot-strategy',
    title: 'PG国际老虎机高手进阶攻略：掌握这些技巧胜率翻倍',
    excerpt: '深度解析PG国际平台老虎机游戏的策略技巧，从选机到投注策略，助你成为老虎机高手。',
    content: `老虎机是PG国际008平台最受欢迎的游戏类型之一。本文将分享资深玩家的进阶技巧，帮助你在老虎机游戏中获得更好的体验。

## 一、选机技巧

在PG国际008平台上，选择适合自己的老虎机至关重要：
- 查看游戏RTP（回报率），选择96%以上的机型
- 了解波动性：低波动适合长时间娱乐，高波动适合追求大奖
- 优先选择带有免费旋转功能的游戏

## 二、资金管理

合理的资金管理是长期游戏的基础：
- 设定单次游戏预算，不超过总资金的10%
- 采用"小额多局"策略，延长游戏时间
- 设定盈亏线，达到目标及时停止

## 三、心态调整

保持良好心态是制胜关键：
- 将游戏视为娱乐，而非赚钱工具
- 不追逐亏损，保持理性判断
- 适时休息，避免疲劳游戏`,
    image: 'https://readdy.ai/api/search-image?query=slot%20machine%20strategy%20guide%20colorful%20gaming%20reels%20golden%20frame%20professional%20gaming%20atmosphere%20dark%20background%20clean%20composition&width=800&height=450&seq=article-02&orientation=landscape',
    category: '攻略教程',
    date: '2026-08-06',
    views: '12.3万',
    tags: ['老虎机', '游戏攻略', '进阶技巧'],
  },
  {
    id: 3,
    slug: 'pg-new-version-features',
    title: 'PG国际008最新版本功能亮点全解析',
    excerpt: 'PG国际008推出全新版本，带来多项功能升级与优化，游戏体验更加流畅，界面焕然一新。',
    content: `PG国际008最新版本正式发布！本次更新带来了众多令人期待的新功能和优化改进。

## 一、界面全面升级

新版本采用了全新的UI设计语言：
- 更加简洁直观的导航布局
- 优化的游戏分类展示
- 个性化的主题切换功能
- 流畅的动画过渡效果

## 二、性能大幅提升

核心技术优化带来显著性能提升：
- 启动速度提升40%
- 游戏加载时间缩短50%
- 内存占用优化30%
- 电池续航优化，长时间游戏不发热

## 三、新增功能

PG国际008新版本新增了多项实用功能：
- 社交好友系统，与好友一起游戏
- 实时排行榜，与全球玩家竞技
- 智能推荐系统，发现更多喜欢的游戏
- 多语言支持，服务全球玩家

立即下载PG国际008最新版本，体验全新升级！`,
    image: 'https://readdy.ai/api/search-image?query=new%20version%20mobile%20gaming%20app%20update%20modern%20interface%20design%20sleek%20dark%20background%20technology%20innovation%20clean%20composition&width=800&height=450&seq=article-03&orientation=landscape',
    category: '平台资讯',
    date: '2026-08-04',
    views: '18.9万',
    tags: ['最新版本', '功能更新', 'PG国际008'],
  },
  {
    id: 4,
    slug: 'pg-fishing-master',
    title: 'PG国际捕鱼达人秘籍：从入门到精通全攻略',
    excerpt: '掌握PG国际平台捕鱼游戏的核心技巧，了解武器选择、瞄准策略与金币管理方法。',
    content: `捕鱼游戏是PG国际008平台上独具特色的游戏类型，融合了射击与策略元素。本文将为玩家提供全面的捕鱼攻略。

## 一、武器选择指南

PG国际平台捕鱼游戏提供多种武器：
- 普通炮：适合新手练习，消耗金币少
- 激光炮：威力中等，适合中等体型鱼类
- 电磁炮：高伤害武器，适合大型鱼类和BOSS
- 散弹炮：覆盖范围广，适合鱼群密集时使用

## 二、瞄准策略

精准的瞄准是提高捕鱼效率的关键：
- 瞄准鱼头位置，提高命中率
- 预判鱼类移动轨迹
- 优先攻击高价值鱼类
- 利用场景道具增加收益

## 三、金币管理

合理管理金币确保持久游戏体验：
- 根据当前金币量选择合适的炮台
- 设定每局消耗上限
- 利用免费弹药和奖励关卡`,
    image: 'https://readdy.ai/api/search-image?query=fishing%20game%20master%20guide%20underwater%20battle%20cannons%20colorful%20fish%20dark%20ocean%20background%20gaming%20atmosphere%20clean%20composition&width=800&height=450&seq=article-04&orientation=landscape',
    category: '攻略教程',
    date: '2026-08-02',
    views: '10.7万',
    tags: ['捕鱼游戏', '游戏攻略', '技巧分享'],
  },
  {
    id: 5,
    slug: 'pg-safety-security',
    title: 'PG国际008平台安全保障体系全面解读',
    excerpt: '了解PG国际008如何通过多重安全机制保障玩家账号安全、资金安全与隐私安全。',
    content: `PG国际008始终将玩家安全放在首位，构建了完善的安全保障体系。

## 一、账号安全

多重账号保护机制确保您的账号万无一失：
- 双重身份验证（2FA）
- 异地登录提醒
- 设备绑定功能
- 安全密码策略强制要求

## 二、资金安全

PG国际平台采用银行级安全标准：
- SSL/TLS加密传输
- 资金托管第三方监管
- 实时风控系统
- 7x24小时异常交易监控

## 三、隐私保护

严格的数据隐私保护政策：
- 玩家信息加密存储
- 不向第三方出售用户数据
- 符合国际数据保护法规
- 用户可随时删除个人数据`,
    image: 'https://readdy.ai/api/search-image?query=cyber%20security%20shield%20protection%20digital%20lock%20icon%20dark%20technology%20background%20safe%20secure%20gaming%20platform%20clean%20composition&width=800&height=450&seq=article-05&orientation=landscape',
    category: '平台资讯',
    date: '2026-07-30',
    views: '9.8万',
    tags: ['安全保障', '平台信任', 'PG国际008'],
  },
  {
    id: 6,
    slug: 'pg-payment-guide',
    title: 'PG国际008充值提现操作全流程详解',
    excerpt: '详细介绍PG国际平台的充值方式、提现流程、到账时间及常见问题解决方案。',
    content: `PG国际008平台提供多种便捷的充值与提现方式，确保交易快速安全。

## 一、充值方式

PG国际008支持以下充值渠道：
- 银行卡转账（实时到账）
- 支付宝/微信支付（秒到账）
- USDT数字货币充值
- 第三方支付平台

## 二、充值步骤

1. 登录PG国际008账号
2. 点击"充值"按钮
3. 选择充值方式
4. 输入充值金额
5. 确认并完成支付

## 三、提现指南

提现操作简单快捷：
- 最低提现金额100元
- 单日提现上限50万元
- 到账时间：银行卡1-2工作日，电子钱包即时到账
- 首次提现需完成实名认证`,
    image: 'https://readdy.ai/api/search-image?query=online%20payment%20transaction%20mobile%20phone%20showing%20digital%20wallet%20secure%20payment%20dark%20background%20clean%20composition&width=800&height=450&seq=article-06&orientation=landscape',
    category: '平台资讯',
    date: '2026-07-28',
    views: '14.2万',
    tags: ['充值提现', '支付指南', 'PG国际008'],
  },
];

export const faqs = [
  {
    question: 'PG国际下载008安全吗？',
    answer: 'PG国际下载008官方正版经过严格的安全检测，确保安装包无毒无恶意软件。我们采用银行级加密技术保护用户数据，并通过第三方安全机构定期审计，确保平台安全可靠。',
  },
  {
    question: '如何下载PG国际008最新版本？',
    answer: '访问PG国际下载008官方网站，点击首页的iOS或Android下载按钮即可获取最新版本安装包。iOS用户需完成企业证书信任设置，Android用户需允许安装未知来源应用。',
  },
  {
    question: 'PG国际008支持哪些设备？',
    answer: 'PG国际008全面支持iOS和Android系统。iOS设备需运行iOS 12.0及以上版本，Android设备需运行Android 8.0及以上版本。同时支持在PC端通过模拟器运行。',
  },
  {
    question: 'PG国际008需要付费吗？',
    answer: 'PG国际008下载安装完全免费。游戏内提供免费试玩模式，充值完全自愿。新用户注册还可领取丰厚的新手礼包。',
  },
  {
    question: 'PG国际008如何联系客服？',
    answer: 'PG国际008提供24小时在线客服支持。您可以通过官网在线客服、官方客服邮箱或微信公众号联系我们，客服团队将在3分钟内响应您的问题。',
  },
  {
    question: 'PG国际008的提现多久到账？',
    answer: '提现到账时间根据方式不同有所差异：电子钱包提现通常即时到账（5分钟内），银行卡提现一般1-2个工作日到账。首次提现需完成实名认证流程。',
  },
];